import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { selectIsAuthenticated } from '../containers/authSlice';
import { entriesUpdateMany } from '../containers/contentSlice';
import { useEntryUpdateMutation } from '../services/records';
import type { EditChartDialogProps } from '../components/EditChartDialog';
import type { Entry } from '../types';

/** Saves an `EditChartDialog` submission, to the API when signed in and to the local store otherwise. */
export function useChartEntryUpdate(): EditChartDialogProps['onSubmit'] {
	const dispatch = useAppDispatch();
	const isAuthenticated = useAppSelector(selectIsAuthenticated);
	const [entryUpdateMutation] = useEntryUpdateMutation();
	return useCallback(
		({ id, repositoryId, title, where, includeArchived, metric, xAxis, xAxisTimeScale, variant, targetA, targetB }) => {
			const updatePayload = {
				id,
				repositoryId,
				title,
				where,
				includeArchived,
				metric: (metric ?? '').trim() || undefined,
				xAxis: (xAxis ?? '').trim() || undefined,
				xAxisTimeScale: xAxisTimeScale ?? null,
				variant: variant ?? 'line',
				targetA: targetA ?? null,
				targetB: targetB ?? null,
			};
			if (isAuthenticated) {
				entryUpdateMutation([updatePayload as Partial<Entry>]);
			} else {
				dispatch(entriesUpdateMany([updatePayload as Partial<Entry>]));
			}
		},
		[dispatch, entryUpdateMutation, isAuthenticated],
	);
}
